import {
  format,
  isValid,
  parseISO,
  startOfDay,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
} from 'date-fns'

export type HistogramDateBucketingOption =
  | 'year'
  | 'half'
  | 'quarter'
  | 'month'
  | 'week'
  | 'day'

export type HistogramDateBucketingConfiguration = {
  value: HistogramDateBucketingOption
  label: string
  bucketingFunction: (category: string) => string | undefined
}

/** Equivalent to date-fns functions like startOfMonth, but this one isn't provided by date-fns */
const startOfHalf = (date: Date) => {
  const month = date.getMonth()
  const year = date.getFullYear()
  const half = Math.floor(month / 6) * 6
  return new Date(year, half, 1)
}

export const HISTOGRAM_DATE_BUCKETING_OPTIONS: Record<
  HistogramDateBucketingOption,
  HistogramDateBucketingConfiguration
> = {
  year: {
    value: 'year',
    label: 'Year',
    bucketingFunction: dateBucketer(startOfYear, 'yyyy'),
  },
  half: {
    value: 'half',
    label: 'Half',
    bucketingFunction: dateBucketer(startOfHalf, 'yyyy-MM'),
  },
  quarter: {
    value: 'quarter',
    label: 'Quarter',
    bucketingFunction: dateBucketer(startOfQuarter, 'yyyy-MM'),
  },
  month: {
    value: 'month',
    label: 'Month',
    bucketingFunction: dateBucketer(startOfMonth, 'yyyy-MM'),
  },
  week: {
    value: 'week',
    label: 'Week',
    bucketingFunction: dateBucketer(startOfWeek, 'yyyy-MM-dd'),
  },
  day: {
    value: 'day',
    label: 'Day',
    // Data should already be bucketed by day, but this formats it appropriately, etc too.
    bucketingFunction: dateBucketer(startOfDay, 'yyyy-MM-dd'),
  },
}

function dateBucketer(
  bucketer: (date: Date) => Date,
  formatPatt: string
): (val: string) => string | undefined {
  return (dateStr: string) => {
    const date = parseISO(dateStr)
    if (!isValid(date)) {
      return undefined
    }
    return format(bucketer(date), formatPatt)
  }
}
